import React from "react";
import { CheckOutlined } from "@ant-design/icons";

const AudienceSourceCard = ({ option, selected, onSelect }) => (
  <button
    type="button"
    onClick={() => onSelect(option.id)}
    className={`tw-w-full tw-flex tw-items-center tw-justify-between tw-rounded-xl tw-border tw-border-solid tw-px-5 tw-py-4 tw-text-left tw-transition-all tw-duration-200 active:tw-scale-[0.99] tw-cursor-pointer tw-shadow-none ${
      selected
        ? "tw-border-[#5D44FF] tw-bg-[#5D44FF]/5"
        : "tw-border-slate-200 tw-bg-white hover:tw-border-[#5D44FF]/40"
    }`}
  >
    <div className="tw-flex tw-items-center tw-gap-3.5 tw-min-w-0">
      <div
        className={`tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-xl tw-text-base tw-flex-shrink-0 tw-transition-all tw-duration-200 ${
          selected
            ? (option.id === "google" || option.id === "outlook"
                ? "tw-bg-white tw-border tw-border-solid tw-border-[#5D44FF]/20"
                : "tw-bg-gradient-to-tr tw-from-[#5D44FF] tw-to-[#8B70FF] tw-text-white")
            : "tw-bg-slate-50 tw-text-slate-600 tw-border tw-border-solid tw-border-slate-100"
        }`}
      >
        {option.icon}
      </div>

      <div className="tw-min-w-0">
        <h3
          className={`tw-m-0 tw-text-[13.5px] tw-font-semibold tw-font-poppins tw-truncate tw-transition-colors tw-duration-200 ${
            selected ? "tw-text-[#5D44FF]" : "tw-text-slate-800"
          }`}
        >
          {option.title}
        </h3>
        <p className="tw-m-0 tw-mt-0.5 tw-text-[11.5px] tw-font-normal tw-text-slate-500 tw-font-inter tw-truncate">
          {option.description}
        </p>
      </div>
    </div>

    <div className="tw-flex-shrink-0 tw-ml-3">
      <div
        className={`tw-h-5 tw-w-5 tw-rounded-full tw-border tw-border-solid tw-flex tw-items-center tw-justify-center tw-transition-all tw-duration-200 ${
          selected
            ? "tw-border-[#5D44FF] tw-bg-[#5D44FF]"
            : "tw-border-slate-300 tw-bg-white"
        }`}
      >
        {selected && (
          <CheckOutlined className="tw-text-white tw-text-[10px] tw-stroke-[2.5]" />
        )}
      </div>
    </div>
  </button>
);

export default AudienceSourceCard;
